import React from "react";
import { Link } from "react-router-dom";
import { Heart, MapPin, GraduationCap, Briefcase, Lock } from "lucide-react";
import { TrustBadges } from "@/components/umaang/TrustBadges";

export default function ProfileCard({ p, onLike }) {
  const first = (p.photos_visible || [])[0];
  return (
    <Link
      to={`/profile/${p.id}`}
      data-testid={`profile-card-${p.id}`}
      className="group block border card-hover overflow-hidden fade-in"
      style={{
        borderRadius: 8,
        borderColor: "var(--umg-border)",
        background: "var(--umg-surface)",
        color: "var(--umg-text)",
      }}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[color:var(--umg-secondary)]">
        {first ? (
          <img
            src={first}
            alt={p.name}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Heart className="w-12 h-12 text-[color:var(--umg-border)]" />
          </div>
        )}
        {/* Match badge */}
        <div
          data-testid={`match-badge-${p.id}`}
          className="absolute top-3 left-3 backdrop-blur border rounded-full px-3 py-1 text-xs font-semibold"
          style={{ background: "var(--umg-surface)", borderColor: "var(--umg-border)", color: "var(--umg-text)" }}
        >
          <span className="text-[#C85A53]">{p.match_percent}%</span>
          <span className="ml-1" style={{ color: "var(--umg-text-2)" }}>match</span>
        </div>
        {p.photos_locked_count > 0 && (
          <div className="absolute top-3 right-3 bg-black/70 text-white text-[10px] px-2 py-1 rounded-full flex items-center gap-1">
            <Lock className="w-3 h-3" /> +{p.photos_locked_count}
          </div>
        )}
        {/* KYC + Premium tier badges — bottom-left, stacked */}
        <div className="absolute bottom-3 left-3 flex flex-wrap gap-1 max-w-[calc(100%-1.5rem)]">
          <TrustBadges profile={p} compact />
        </div>
      </div>
      <div className="p-4">
        <div className="flex items-baseline justify-between gap-2">
          <h3 className="font-display text-xl truncate" style={{ color: "var(--umg-text)" }}>{p.name}</h3>
          {p.age && <span className="text-sm" style={{ color: "var(--umg-text-2)" }}>{p.age}</span>}
        </div>
        {p.member_id && (
          <div className="text-[10px] uppercase tracking-widest mt-0.5" style={{ color: "var(--umg-text-2)" }}>
            <span className="text-[#7C3AED] font-semibold">{p.member_id}</span>
          </div>
        )}
        <div className="mt-2 space-y-1 text-xs" style={{ color: "var(--umg-text-2)" }}>
          {p.profession && (
            <div className="flex items-center gap-1.5 truncate">
              <Briefcase className="w-3 h-3 shrink-0" /> {p.profession}
            </div>
          )}
          {p.education && (
            <div className="flex items-center gap-1.5 truncate">
              <GraduationCap className="w-3 h-3 shrink-0" /> {p.education}
            </div>
          )}
          {p.city && (
            <div className="flex items-center gap-1.5 truncate">
              <MapPin className="w-3 h-3 shrink-0" /> {p.city}
              {p.state ? `, ${p.state}` : ""}
              {typeof p.distance_km === "number" && (
                <span data-testid="distance-badge" className="ml-1 text-[10px] text-[#C85A53]">· {p.distance_km} km</span>
              )}
            </div>
          )}
        </div>
      </div>
    </Link>
  );
}
